import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-edit-header',
  templateUrl: './edit-header.component.html',
  styleUrls: ['./edit-header.component.scss'],
})
export class EditHeaderComponent {
  @Input() title!: string;

  constructor(private router: Router) {}

  close(): void {
    this.router.navigate([{ outlets: { edit: null } }]);
  }
}
